// @flow

// Libs
import React from 'react'
import _size from 'lodash/size'
import _flatMap from 'lodash/flatMap'
import _map from 'lodash/map'
import { FormattedMessage } from 'react-intl'

// Styles
import { error } from 'fc-styles/src/colors'
const listStyle = {
  fontSize: '12px',
  padding: 15,
  color: error(),
  backgroundColor: error(0.2),
}

type Props = {
  errors: BadResponses,
  messages: Object,
  style: Object,
}

export default function Errors ({errors, messages, style}: Props): ?React.Element<any> {
  if (_size(errors)) {
    const list = _flatMap(errors, (pairs: BadResponse): Array<React.Element<any>> => {
      return _map(pairs, function (err1: BadResponse, keyVal: string): React.Element<any> {
        let err = err1
        let values = {}

        if (typeof err1 === 'object') {
          err = err1.key
          values = err1.values
        }

        const msg = messages && messages[err]
          ? <FormattedMessage {...messages[err]} values={values} />
          : messages && messages[keyVal]
            ? <FormattedMessage {...messages[keyVal]} values={values} />
            : err
        return (
          <li key={err} style={listStyle}>
            {msg}
          </li>
        )
      })
    })

    return (
      <ul style={style}>{list}</ul>
    )
  } else if (errors && typeof errors === 'object' && Object.prototype.hasOwnProperty.call(errors, 'statusText')) {
    return (
      <li key={errors.statusText} style={listStyle}>
        {errors.statusText}
      </li>
    )
  }

  return null
}
